export default __webpack_public_path__ + "static/media/VectorVote.21dd555f.svg";